import values from 'lodash/values';
import { parseConfig } from '../../../../shared/config';
import * as ALL_STATES from '../../../../shared/model/constants/locations';
import {
  CITIES,
} from '../../constants/taxonomy/locations';
import {
  OFFICES,
  INDUSTRIAL_WAREHOUSE,
} from '../../../../shared/model/constants/propertyTypes';
import { channelObjects } from '../../../../shared/model/constants/channels';

const buildLinkPrefix = (
  channelObject,
  propertyTypeObject,
) => {
  const isSoldOrLeased =
    channelObject === channelObjects.Sold || channelObject === channelObjects.Leased;
  const channelText = channelObject.humanReadable;
  const propertyTypeText = propertyTypeObject
    ? propertyTypeObject.longDisplayText
    : 'Commercial Property';

  return isSoldOrLeased
    ? `${channelText} ${propertyTypeText}`
    : `${propertyTypeText} ${channelText}`;
};

const buildUri = (
  channelObject,
  location,
  propertyTypeObject,
) => {
  const websiteRoot = parseConfig().WEBSITE_ROOT;
  const channelText = channelObject.url;
  const locationText = location.url;

  return propertyTypeObject
    ? `${websiteRoot}/${channelText}/${locationText}/${propertyTypeObject.url}/`
    : `${websiteRoot}/${channelText}/${locationText}/`;
};

export const buildLinks = (
  locations,
  channelObject,
  propertyTypeObject,
) => locations.map(
  location => ({
    prefix: buildLinkPrefix(channelObject, propertyTypeObject),
    region: location.display,
    uri: buildUri(channelObject, location, propertyTypeObject),
  }),
);

const STATES = values(ALL_STATES);

export const buildCommonTabs = channelObject => ([
  {
    name: 'Top Locations',
    links: [
      ...buildLinks(STATES, channelObject),
      ...buildLinks(CITIES, channelObject),
    ],
  },
  {
    name: OFFICES.longDisplayText,
    links: [
      ...buildLinks(STATES, channelObject, OFFICES),
      ...buildLinks(CITIES, channelObject, OFFICES),
    ],
  },
  {
    name: INDUSTRIAL_WAREHOUSE.longDisplayText,
    links: [
      ...buildLinks(STATES, channelObject, INDUSTRIAL_WAREHOUSE),
      ...buildLinks(CITIES, channelObject, INDUSTRIAL_WAREHOUSE),
    ],
  },
]);
